export default __webpack_public_path__ + "static/media/modal-bg-left.d0ec6c4a.png";